import { render, staticRenderFns } from "./Beneficiary.vue?vue&type=template&id=c42d62aa"
import script from "./Beneficiary.vue?vue&type=script&lang=js"
export * from "./Beneficiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports